'use client';

import type React from 'react';

import { FormGroup } from '../../templates/form-group/form-group';
import type { InputProps } from './input.types';

function getContainerStyle(withButton: boolean) {
  if (withButton)
    return 'hc-input__container--with-button hc-sidebar-layout--reverse';

  return '';
}

export function Input({
  label,
  icon,
  helpText,
  errorText,
  disabled,
  error,
  name,
  id,
  withButton = false,
  button,
  className,
  required,
  ref,
  'data-testid': dataTestId,
  ...inputProps
}: InputProps & {
  ref?: React.Ref<HTMLInputElement>;
}) {
  const showErrors = error;
  const inputId = id || name;

  return (
    <FormGroup className={className} disabled={disabled} error={showErrors}>
      <label className="hc-label">
        {label}
        <div className={getContainerStyle(withButton)}>
          <div className="hc-form-control--icon-right relative">
            <input
              {...inputProps}
              ref={ref}
              required={required}
              disabled={disabled}
              name={name}
              id={inputId}
              aria-invalid={showErrors}
              data-testid={dataTestId ?? 'core-input'}
            />
            {icon}
          </div>
          {button}
        </div>
      </label>
      <div className="hc-help-text">{helpText}</div>
      <div className="hc-error-text">{errorText}</div>
    </FormGroup>
  );
}
